import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ClosedEye = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
        viewBox='0 0 20 20'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        ref={ref}
        {...props}
    >
        <path
            d='M1.66634 4.39183L2.73301 3.3335L16.6663 17.2668L15.608 18.3335L13.0413 15.7668C12.083 16.0835 11.0663 16.2502 9.99967 16.2502C5.83301 16.2502 2.27467 13.6585 0.833008 10.0002C1.40801 8.5335 2.32467 7.24183 3.49134 6.21683L1.66634 4.39183ZM9.99967 7.50016C10.6627 7.50016 11.2986 7.76355 11.7674 8.2324C12.2363 8.70124 12.4997 9.33712 12.4997 10.0002C12.4997 10.2918 12.4497 10.5752 12.358 10.8335L9.16634 7.64183C9.42467 7.55016 9.70801 7.50016 9.99967 7.50016ZM9.99967 3.75016C14.1663 3.75016 17.7247 6.34183 19.1663 10.0002C18.483 11.7335 17.3247 13.2335 15.833 14.3252L14.6497 13.1335C15.783 12.3502 16.7163 11.2835 17.3497 10.0002C15.9747 7.20016 13.133 5.41683 9.99967 5.41683C9.09134 5.41683 8.19967 5.56683 7.36634 5.8335L6.08301 4.5585C7.28301 4.04183 8.60801 3.75016 9.99967 3.75016ZM2.64967 10.0002C4.02467 12.8002 6.86634 14.5835 9.99967 14.5835C10.5747 14.5835 11.1413 14.5252 11.6663 14.4085L9.76634 12.5002C8.57467 12.3752 7.62467 11.4252 7.49967 10.2335L4.66634 7.39183C3.84134 8.10016 3.14967 8.9835 2.64967 10.0002Z'
            fill='currentColor'
        />
    </svg>
));
